import { FC } from 'react';
import AttachFileOutlined from '@mui/icons-material/AttachFileOutlined';
import { Box, Button, Typography } from '@mui/material';
import { FirmDailyNavDay } from 'pages/Intelligence/DailyNav/daily-nav.api.types';
import { ApproverNoteProps } from './ReportDialog.props';

// The one place that decides there is an approver record to show, so the Send
// tab cannot offer a tab that renders nothing.
export const hasApproverNote = (day?: FirmDailyNavDay | null): boolean =>
  Boolean(day?.finalize_approver_note || day?.staff_finalize_confirmation) ||
  (day?.finalize_attachments?.length ?? 0) > 0;

// Read-only, and shown to clients as well as staff: once a day is finalized,
// who approved its prices and the documents behind that call are part of the
// record everyone reading the day needs.
const ApproverNote: FC<ApproverNoteProps> = ({ day, onDownloadAttachment, topMargin = 2 }) => {
  const attachments = day?.finalize_attachments ?? [];
  const note = day?.finalize_approver_note || day?.staff_finalize_confirmation;
  if (!hasApproverNote(day)) {
    return null;
  }
  return (
    <Box mt={topMargin} data-testid="daily-nav-approver-note">
      <Typography variant="body2" fontWeight={600}>
        Approved by
      </Typography>
      {note && (
        <Typography variant="body2" mt={0.5} data-testid="daily-nav-approver-note-body">
          {note}
        </Typography>
      )}
      {attachments.map(attachment => (
        <Button
          key={attachment.id}
          size="small"
          startIcon={<AttachFileOutlined sx={{ fontSize: 14 }} />}
          data-testid={`daily-nav-approver-note-attachment-${attachment.id}`}
          onClick={() => attachment.id != null && onDownloadAttachment(attachment.id)}
          sx={{ display: 'flex', fontSize: 12, padding: 0, textTransform: 'none' }}>
          {`${attachment.filename}.${attachment.file_type}`}
        </Button>
      ))}
    </Box>
  );
};

export default ApproverNote;
